/* eslint-disable max-len */
import React, { useEffect, useRef } from 'react';
import {
  Card,
  Grid,
  Button,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { useParams } from 'react-router-dom';
import { BidPriceDetailNames } from '../../utils/constants';
import { RootState } from '../../../../../redux/rootState';
import {
  assignBidPricing, constructBidPricingPayload, getBidValue, getValidNumeric,
} from '../../utils/helper';
import { BidDetailsPayload, ComponentBidDetailsProps, UpdateBidPayload } from '../../utils/types';
import { BidDetailsFormComponent } from './formComponent';
import { setAirfareError, updateBidStart } from '../../redux/bidWorksheetSlice';
import { showErrorToaster } from '../../../../../Common/ComponentToast/ComponentSuccessToasts';

function ComponentBidDetails({
  control, setValue, watch, getValues,
}:ComponentBidDetailsProps) {
  const {
    selectedBid, bidPricing, bidId, selectedTab, disableButton, updatedBidDetails,
  } = useSelector((state:RootState) => state.bidsReducer);
  const dispatch = useDispatch();
  const { jobId } = useParams();

  const bidPricingValues = watch();

  const flightCharge = watch(BidPriceDetailNames.FlightCharge) || 0;
  const airfare = watch(BidPriceDetailNames.Airfare) || 0;
  const eqCharge = watch(BidPriceDetailNames.EquipmentCharges);
  const otherCharge = watch(BidPriceDetailNames.OtherCharges) || 0;
  const SafetyTraining = watch(BidPriceDetailNames.SafetyTraining) || 0;
  const SafetyTrainingCharges = watch(BidPriceDetailNames.SafetyTrainingCharges) || 0;
  const nonProdDays = watch(BidPriceDetailNames.NonProdDays);
  const CommunicationCharges = watch(BidPriceDetailNames.CommunicationCharges);
  const ParkingChanges = watch(BidPriceDetailNames.ParkingChanges);
  const SafetyCharges = watch(BidPriceDetailNames.SafetyCharges);
  const NightCharges = watch(BidPriceDetailNames.NightCharges);
  const SafetyManagementFee = watch(BidPriceDetailNames.SafetyManagementFee);
  const OTSaturday = watch(BidPriceDetailNames.OTSaturday);
  const OTSunday = watch(BidPriceDetailNames.OTSunday);
  const OTHoliday = watch(BidPriceDetailNames.OTHoliday);
  const AdditionalCharges = watch(BidPriceDetailNames.AdditionalCharges);
  const TotalFlightExpense = watch(BidPriceDetailNames.TotalFlightExpense);
  const TotalMiscExpense = watch(BidPriceDetailNames.TotalMiscExpense);
  const NonProdDaysAmount = watch(BidPriceDetailNames.NonProdDaysAmount);
  const TubeCharge = watch(BidPriceDetailNames.TubeCharge);
  const DriveExpense = watch(BidPriceDetailNames.DriveExpense);
  const LodgePerDiem = watch(BidPriceDetailNames.LodgePerDiem);
  const Markup = watch(BidPriceDetailNames.Markup);
  const AbsShipping = watch(BidPriceDetailNames.AbsShipping);
  const FluxShipping = watch(BidPriceDetailNames.FluxShipping);
  const CorrectionType = watch(BidPriceDetailNames.CorrectionType);
  const CorrectionFactor = watch(BidPriceDetailNames.CorrectionFactor);

  useEffect(() => {
    if (bidPricing?.AdditionalInfo && !selectedBid?.BidId) {
      setValue(BidPriceDetailNames.FlightCharge, getBidValue(bidPricing?.FlightExpense));
      // setValue(BidPriceDetailNames.EquipmentCharges, getBidValue(bidPricing?.EquipmentCharge));
      setValue(BidPriceDetailNames.EquipmentCharges, 0);
    }
  }, [bidPricing]);

  // Flight Expense
  useEffect(() => {
    if (getValidNumeric(airfare) > 0) {
      setValue(BidPriceDetailNames.TotalFlightExpense, Math.ceil(getValidNumeric(flightCharge) + getValidNumeric(airfare)));
    } else {
      setValue(BidPriceDetailNames.TotalFlightExpense, 0);
    }
  }, [flightCharge, airfare]);

  // Misc Expense
  useEffect(() => {
    setValue(BidPriceDetailNames.TotalMiscExpense, Math.ceil(getValidNumeric(Number(getValues(BidPriceDetailNames.EquipmentCharges))) + getValidNumeric(Number(getValues(BidPriceDetailNames.OtherCharges)))) || 0);
  }, [eqCharge, otherCharge]);

  // Additional Charges
  useEffect(() => {
    const val = getValidNumeric(CommunicationCharges)
    + getValidNumeric(ParkingChanges) + getValidNumeric(SafetyTrainingCharges) + getValidNumeric(SafetyCharges) + getValidNumeric(NightCharges)
    + getValidNumeric(OTSaturday) + getValidNumeric(OTSunday) + getValidNumeric(OTHoliday) + getValidNumeric(SafetyManagementFee);
    setValue(BidPriceDetailNames.AdditionalCharges, Math.ceil(val));
  }, [CommunicationCharges, ParkingChanges, SafetyCharges, NightCharges, OTSaturday, OTSunday, OTHoliday, SafetyTrainingCharges, SafetyManagementFee]);

  useEffect(() => {
    if (selectedBid) {
      assignBidPricing(setValue, selectedBid);
    }
  }, [selectedBid]);

  // total Markup
  useEffect(() => {
    // if ((selectedBid ? (selectedBid?.BidDetails?.IsBidNonMinimum === false) : true) && bidPricing?.IsAllowMarkUp === false) {
    //   setValue(BidPriceDetailNames.Markup, 0);
    // } else if (Number(bidPricing?.MarkupPercentage) >= 0) {
    //   const markup = bidPricing?.MarkupPercentage;
    //   const val = getValidNumeric(TubeCharge) + getValidNumeric(DriveExpense)
    //   + getValidNumeric(LodgePerDiem) + getValidNumeric(TotalFlightExpense)
    //   + getValidNumeric(TotalMiscExpense) + getValidNumeric(NightCharges) + getValidNumeric(OTSaturday)
    //   + getValidNumeric(OTSunday) + getValidNumeric(OTHoliday) + getValidNumeric(SafetyTrainingCharges)
    //   + getValidNumeric(NonProdDaysAmount);
    //   setValue(BidPriceDetailNames.Markup, Math.ceil(getValidNumeric((markup / 100) * val)));
    // }
    if (Number(bidPricing?.MarkupPercentage) >= 0) {
      const markup = bidPricing?.MarkupPercentage;
      const val = getValidNumeric(TubeCharge) + getValidNumeric(DriveExpense)
      + getValidNumeric(LodgePerDiem) + getValidNumeric(TotalFlightExpense)
      + getValidNumeric(TotalMiscExpense) + getValidNumeric(NightCharges) + getValidNumeric(OTSaturday)
      + getValidNumeric(OTSunday) + getValidNumeric(OTHoliday) + getValidNumeric(SafetyTrainingCharges)
      + getValidNumeric(NonProdDaysAmount);
      setValue(BidPriceDetailNames.Markup, Math.ceil(getValidNumeric((markup / 100) * val)));
    }
  }, [TubeCharge, DriveExpense, NonProdDaysAmount,
    LodgePerDiem, TotalFlightExpense, TotalMiscExpense, NightCharges, OTSaturday, OTSunday, OTHoliday, SafetyTrainingCharges]);

  // Total Bid
  useEffect(() => {
    if (Number(bidPricing?.MarkupPercentage) >= 0) {
      const correctionVal = CorrectionType === '1' ? -1 * (CorrectionFactor) : CorrectionFactor;
      const val = [
        getValidNumeric(getValues(BidPriceDetailNames.TotalMiscExpense)), getValidNumeric(TotalFlightExpense),
        getValidNumeric(NonProdDaysAmount), getValidNumeric(TubeCharge), getValidNumeric(DriveExpense),
        getValidNumeric(AdditionalCharges), getValidNumeric(LodgePerDiem), getValidNumeric(getValues(BidPriceDetailNames.Markup)),
        getValidNumeric(FluxShipping), getValidNumeric(AbsShipping), getValidNumeric(correctionVal)]
        .reduce((acc:number, curr:number) => acc + curr, 0);
      setValue(BidPriceDetailNames.TotalBid, Math.ceil(val) || 0);
    }
  }, [TotalMiscExpense, TotalFlightExpense, NonProdDaysAmount, CorrectionType, CorrectionFactor,
    TubeCharge, DriveExpense, AdditionalCharges, LodgePerDiem, Markup, FluxShipping, AbsShipping]);

  useEffect(() => {
    if (getValidNumeric(SafetyTraining) >= 2
      && selectedBid?.BidPriceDetails?.IsSafetyTraining
      && getValidNumeric(selectedBid?.BidPriceDetails?.SafetyTrainingTime) === getValidNumeric(SafetyTraining)
    ) {
      setValue(
        BidPriceDetailNames.SafetyTrainingCharges,
        Math.ceil(getValidNumeric(selectedBid?.BidPriceDetails?.SafetyTrainingCharge)) || 0,
      );
    } else if (getValidNumeric(SafetyTraining) >= 2 && bidPricing?.AdditionalInfo?.SafetyTraining) {
      setValue(
        BidPriceDetailNames.SafetyTrainingCharges,
        Math.ceil(getValidNumeric(bidPricing?.AdditionalInfo?.SafetyTraining) * getValidNumeric(SafetyTraining)) || 0,
      );
    } else {
      setValue(BidPriceDetailNames.SafetyTrainingCharges, 0);
    }
  }, [SafetyTraining]);

  useEffect(() => {
    if (bidPricing?.NonProdDaysAmount) {
      setValue(BidPriceDetailNames.NonProdDaysAmount, Math.ceil(getValidNumeric(nonProdDays) * getValidNumeric(bidPricing?.NonProdDaysAmount)));
    }
  }, [nonProdDays]);

  useEffect(() => {
    if (Number(bidPricingValues.airfare) > 0) {
      dispatch(setAirfareError(false));
    }
  }, [bidPricingValues.airfare]);

  const handleSave = () => {
    let IsOutOfCountry = false;
    if (Object.keys(updatedBidDetails).length > 0) {
      IsOutOfCountry = updatedBidDetails.outOfCountry || false;
    } else {
      IsOutOfCountry = selectedBid?.BidDetails.IsOutOfCountry || false;
    }
    if (IsOutOfCountry && !(Number(bidPricingValues.airfare) > 0)) {
      showErrorToaster('Airfare is required as the Job is based outside the US');
      dispatch(setAirfareError(true));
      return;
    }
    // if (bidPricingValues.isSafetyCharges === true && Number(bidPricingValues.SafetyCharge) === 0) {
    //   showErrorToaster('Safety charges cannot be 0');
    // } else {
    let bidPayload: BidDetailsPayload = selectedBid?.BidDetails;
    if (Object.keys(updatedBidDetails).length > 0) {
      bidPayload = {
        JobId: String(jobId),
        GulfCoastFL: updatedBidDetails.gulfCoastFL || false,
        AnalystId: updatedBidDetails.analystName || '0',
        DriveFrom: updatedBidDetails.driveFrom || '0',
        RoundTripMiles: Number(updatedBidDetails.roundTripMiles) || 0,
        IsOutOfCountry: updatedBidDetails.outOfCountry || false,
      };
    }
    const bidPricingPayload = constructBidPricingPayload(bidPricingValues, bidPricing?.IsAllowMarkUp);
    const payload: UpdateBidPayload = {
      BidId: bidId,
      BidDetails: { ...bidPayload, JobId: selectedBid?.BidDetails.JobId },
      BidPriceDetails: bidPricingPayload,
    };
    dispatch(updateBidStart(payload));
    // }
  };

  const targetDivRef5 = useRef<HTMLButtonElement | null>(null);

  const goToTop = () => {
    const targetDiv = targetDivRef5.current;
    targetDiv?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  return (
    <>
      {selectedTab === 2
      && (
      <div style={{ display: 'flex', justifyContent: 'right', marginBottom: '8px' }}>
        <Button type="button" className="button_save_and_next" onClick={() => goToTop()}>Go to Save</Button>
      </div>
      )}
      <Card>
        <div className="special_location_container">
          <div className="customerInfo">
            Bid Details
          </div>
        </div>
        <div className="customerInfo_main_container">
          <BidDetailsFormComponent control={control} watch={watch} setValue={setValue} />
        </div>
      </Card>
      {selectedTab === 2
      && (
      <Grid item xs={12} sm={12} md={12}>
        <div className="save_and_next_div mt20">
          <Button disabled={disableButton} ref={targetDivRef5} type="submit" className="button_save_and_next" onClick={handleSave}>Save</Button>
        </div>
      </Grid>
      )}
    </>
  );
}

export default ComponentBidDetails;
